const config = {
    apiBaseUrl: 'http://localhost:5000'
};

export default config;
